var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14010_1313)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14010_1313",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7144 12.003L16.2939 11.1764C16.4373 10.3968 16.4373 9.5971 16.2939 8.81753L17.7144 7.99092C17.8778 7.89684 17.9512 7.70195 17.8978 7.5205C17.5277 6.32426 16.8975 5.24228 16.0738 4.34174C15.9471 4.20398 15.7403 4.17037 15.5803 4.26446L14.1598 5.09107C13.5629 4.5736 12.8759 4.17373 12.1323 3.91164V2.26178C12.1323 2.07361 12.0023 1.90896 11.8189 1.86864C10.5951 1.5931 9.34127 1.60654 8.1775 1.86864C7.99409 1.90896 7.86405 2.07361 7.86405 2.26178V3.915C7.12377 4.18046 6.43684 4.58032 5.83661 5.09443L4.41941 4.26782C4.25602 4.17373 4.05261 4.20398 3.92589 4.34511C3.10225 5.24228 2.47201 6.32426 2.10187 7.52386C2.04518 7.70531 2.12188 7.9002 2.28528 7.99429L3.70581 8.8209C3.56242 9.60046 3.56242 10.4002 3.70581 11.1798L2.28528 12.0064C2.12188 12.1005 2.04852 12.2953 2.10187 12.4768C2.47201 13.673 3.10225 14.755 3.92589 15.6555C4.05261 15.7933 4.25935 15.8269 4.41941 15.7328L5.83995 14.9062C6.43684 15.4237 7.12377 15.8236 7.86738 16.0857V17.7389C7.86738 17.927 7.99743 18.0917 8.18083 18.132C9.40463 18.4076 10.6584 18.3941 11.8222 18.132C12.0056 18.0917 12.1357 17.927 12.1357 17.7389V16.0857C12.8759 15.8202 13.5629 15.4203 14.1631 14.9062L15.5836 15.7328C15.747 15.8269 15.9504 15.7967 16.0771 15.6555C16.9008 14.7584 17.531 13.6764 17.9012 12.4768C17.9512 12.292 17.8778 12.0971 17.7144 12.003ZM9.99818 12.6851C8.52763 12.6851 7.33051 11.4788 7.33051 9.99697C7.33051 8.51512 8.52763 7.3088 9.99818 7.3088C11.4687 7.3088 12.6659 8.51512 12.6659 9.99697C12.6659 11.4788 11.4687 12.6851 9.99818 12.6851Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14010_1313)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#6C6C6C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14010_1313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.c39d2839c1c3fcc4d7ac3fa8723c5419.svg";
export { ForwardRef as ReactComponent };